import classnames from 'classnames';
import { Image } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './CommonCreativeRenderer.css';

const BLOCK = 'common-creative-renderer';

export type CommonCreativeRendererData = {
    thumbnail: string;
    alt: string;
};

export interface CommonCreativeRendererProps {
    item: CommonCreativeRendererData;
    controls?: React.ReactNode;
    cls?: string;
}

export class CommonCreativeRenderer extends React.PureComponent<CommonCreativeRendererProps> {
    render() {
        const { item, controls, cls } = this.props;

        return (
            <div className={classnames(Bem.cls(BLOCK, 'wrapper'), cls)}>
                <div className={Bem.cls(BLOCK, 'inner')}>
                    <div className={Bem.cls(BLOCK, 'thumb')}>
                        <div className={Bem.cls(BLOCK, 'thumb-inner')}>
                            <Image cls={Bem.cls(BLOCK, 'image')} url={item.thumbnail} alt={item.alt} />
                        </div>
                    </div>
                </div>
                {controls && <div className={Bem.cls(BLOCK, 'overlay')}>{controls}</div>}
                {this.props.children}
            </div>
        );
    }
}
